export default __webpack_public_path__ + "static/media/bike-new.e8da7f56.png";